(function(){
  'use strict';
  function init(){
    var add=document.getElementById('pdpAdd'),flow=document.getElementById('jsGpm'),source=document.getElementById('jpsFlowCopy');
    if(!add||!flow||!source)return;
    var published=(add.dataset.publishedFlow||'').trim();
    var range=published.match(/^(\d+(?:\.\d+)?)\s*(?:[-–—]|to)\s*(\d+(?:\.\d+)?)\s*GPM$/i);
    if(!range||Number(range[1])<=0||Number(range[2])<Number(range[1]))return;
    var select=document.getElementById('variantSel');
    if(select&&Array.from(select.options).some(function(option){return /\d+(?:\.\d+)?\s*GPM/i.test(option.dataset.title||'');}))return;
    if(document.getElementById('jpsPublishedFlowReview'))return;
    var text=JSON.parse(source.textContent),box=document.createElement('div'),field=document.createElement('input');
    box.className='jps-flow-resolution';box.id='jpsPublishedFlowReview';box.hidden=true;box.setAttribute('role','status');
    field.type='hidden';field.id='jpsRangeReview';
    var anchor=document.getElementById('fitBox')||flow.closest('.jetter-setup')||flow;anchor.after(box);add.after(field);
    function sync(){
      var value=flow.value.trim(),number=Number(value),outside=!!value&&Number.isFinite(number)&&number>0&&(number<Number(range[1])||number>Number(range[2]));
      add.dataset.flowRangeReview=outside?'1':'0';field.value=outside?text.range_property.replace('{flow}',value).replace('{range}',published):'';box.hidden=!outside;box.replaceChildren();
      if(outside){
        var warning=document.createElement('p');warning.textContent=text.range_warning.replace('{flow}',value).replace('{range}',published);
        var note=document.createElement('p');note.textContent=text.range_order;
        var link=document.createElement('a'),url=new URL('/pages/contact',location.origin);url.searchParams.set('intent','machine');
        var handle=location.pathname.match(/\/products\/([a-z0-9-]+)/);if(handle)url.searchParams.set('product',handle[1]);url.searchParams.set('jps_gpm',value);
        var psi=document.getElementById('jsPsi');if(psi&&Number(psi.value)>0)url.searchParams.set('jps_psi',psi.value);
        var preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
        link.href=url.toString();link.textContent=text.help;box.append(warning,note,link);
      }
      if(window.JPS_syncPurchaseState)window.JPS_syncPurchaseState();
      document.dispatchEvent(new Event('jps:purchase-state'));
    }
    flow.addEventListener('input',sync);flow.addEventListener('change',sync);
    var psi=document.getElementById('jsPsi');if(psi)psi.addEventListener('change',sync);
    var clear=document.getElementById('jsClear');if(clear)clear.addEventListener('click',sync);
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
